import React, { useState } from 'react';
import { useAdmin } from '../../contexts/AdminContext';

const AdminLoginModal = () => {
  const { login, showLoginModal, setShowLoginModal } = useAdmin();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(username, password);

    if (!result.success) {
      setError(result.error);
      setLoading(false);
    } else {
      setUsername('');
      setPassword('');
      setLoading(false);
    }
  };

  const handleClose = () => {
    setShowLoginModal(false);
    setUsername('');
    setPassword('');
    setError('');
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      handleClose();
    }
  };

  if (!showLoginModal) {
    return null;
  }

  const modalStyles = {
    backdrop: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000,
    },
    card: {
      backgroundColor: '#fff',
      borderRadius: '2px',
      padding: '40px',
      width: '100%',
      maxWidth: '300px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
    },
    input: {
      padding: '10px 12px',
      border: '1px solid #ddd',
      borderRadius: '2px',
      fontSize: '14px',
      fontFamily: 'inherit',
      outline: 'none',
      transition: 'border-color 0.2s',
    },
    inputFocus: {
      borderColor: '#333',
    },
    button: {
      padding: '10px 16px',
      backgroundColor: '#333',
      color: '#fff',
      border: 'none',
      borderRadius: '2px',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      transition: 'background-color 0.2s',
    },
    buttonHover: {
      backgroundColor: '#555',
    },
    error: {
      color: '#c33',
      fontSize: '13px',
      lineHeight: '1.4',
      margin: '0',
      minHeight: '16px',
    },
  };

  return (
    <div
      style={modalStyles.backdrop}
      onClick={handleBackdropClick}
      onKeyDown={handleKeyDown}
      role="dialog"
      aria-modal="true"
    >
      <div style={modalStyles.card}>
        <form style={modalStyles.form} onSubmit={handleSubmit} autoComplete="off">
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            onKeyDown={handleKeyDown}
            style={modalStyles.input}
            autoComplete="off"
            autoFocus
            disabled={loading}
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={handleKeyDown}
            style={modalStyles.input}
            autoComplete="new-password"
            disabled={loading}
          />
          <button
            type="submit"
            style={modalStyles.button}
            disabled={loading}
            onMouseEnter={(e) => {
              if (!loading) e.target.style.backgroundColor = modalStyles.buttonHover.backgroundColor;
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = modalStyles.button.backgroundColor;
            }}
          >
            {loading ? 'Authenticating...' : 'Submit'}
          </button>
          {error && <p style={modalStyles.error}>{error}</p>}
        </form>
      </div>
    </div>
  );
};

export default AdminLoginModal;
